import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonDashboardModule(props) {
    const map = useMapContext()
    const {mapTypeCode, prjId, subTypeCode, sVer} = map.data

    if (! (
        'SA_MAP' === mapTypeCode &&
        'BODA2' === subTypeCode
    )) {
        return null
    }

    const onClick = () => openWindow('/UvDetail', {prjId, sVer})

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            编辑界面视图
        </MenuButton>
    )
}
